exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-table-background[data-v-92260f04]{background-color:#f0f7fe}.preview-table-data-background[data-v-92260f04]{background-color:#ddecfd}", ""]);

// exports
